<mat-form-field appearance="outline" [formGroup]="formGroup">
  <mat-label>Car model</mat-label>
  <input matInput placeholder="Car model" aria-label="Car model" (keyup)="findVehicle()" [matAutocomplete]="auto" formControlName="{{fieldName}}" [disabled]="true">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCarName" (optionSelected)="updateSelectedCarModel($event.option.value)">
    <mat-option *ngFor="let car of filteredCars" [value]="car">
      <span>{{ car.text }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-error>
    <app-validation-partial
        [formGroup]="formGroup"
        [fieldName]="fieldName"
    ></app-validation-partial>
  </mat-error>
</mat-form-field>
